export const langId = document.documentElement.lang || "";
